module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_vm._v("About the author")]), _vm._v(" "), _c('p', [_vm._v("Marco Preshevski was born in 1971 in Luton, United Kingdom. After spending his childhood and adolescent years in the west of England, he attended the University of Bristol from which he graduated in 1993 with a Bachelor of Science degree (with honours) in Chemistry. Marco worked for almost twenty years in healthcare marketing communications including ten years’ experience in advertising and brand development, before moving out to Australia. Marco lives in Sydney, New South Wales, Australia, where he spends as much time as possible raising his daughter.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0